import React from 'react';

import { IntlMsg } from '../IntlMsg/intl-msg.component';
import { IIntlMessage } from '../IntlMsg/intl-msg.types';

interface IFieldErrorProps {
  // A Formik/Yup error string. Schemas set their yup message from a defineMessages
  // descriptor's defaultMessage, so this matches back to render it via IntlMsg.
  error?: string | false;
  catalog: Record<string, IIntlMessage>;
}

// Renders a Formik/Yup validation error through the i18n layer. Falls back to the
// raw string when no descriptor matches, so legacy plain-string schemas still render.
export const FieldError: React.FC<IFieldErrorProps> = ({ error, catalog }) => {
  if (!error) return null;
  const descriptor = Object.values(catalog).find(m => m.defaultMessage === error);
  return descriptor ? <IntlMsg {...descriptor} /> : <>{error}</>;
};
